module.exports = __webpack_public_path__ + "static/GP-827232bc56a1647f7f447c571804602b.svg";